import { CreditNoteRepository } from "../repositories/CreditNoteRepository";
import { CreditsAppliedResultEntity } from "../entities/CreditNoteEntity";

/**
 * Get Credits Applied Use Case
 * Fetches all credits applied to the invoice or bill associated with a credit note
 */
export class GetCreditsAppliedUseCase {
  constructor(private repository: CreditNoteRepository) {}

  async execute(
    creditNoteId: number
  ): Promise<CreditsAppliedResultEntity | null> {
    return await this.repository.getCreditsApplied(creditNoteId);
  }
}
